import React from "react";
import { FormLabel as ChakraFormLabel } from "@chakra-ui/react";

// Types
export interface FormLabelProps {
	htmlFor?: string;
	required?: boolean;
	label?: string;
	whiteLabel?: boolean;
	noMargin?: boolean;
	children?: React.ReactNode;
	className?: string;
}

// Base Label Component (non-Formik)
export const FormLabel: React.FC<FormLabelProps> = ({
	htmlFor,
	required = false,
	label = "",
	whiteLabel = false,
	noMargin = false,
	children,
	className = "",
}) => {
	const isEmptyLabel = label?.trim() === "";

	return (
		<ChakraFormLabel
			htmlFor={htmlFor}
			className={`text-sm font-semibold ${className}`}
			m={0}
			mb={noMargin ? 0 : 1.5}
		>
			<div
				className="test_clickable_label flex items-center justify-start gap-1"
				data-testid={`label-${label}`}
			>
				{isEmptyLabel ? (
					<div className="whitespace-pre-line font-roboto font-medium text-white leading-5 mb-[5.9px]">
						{label}
					</div>
				) : (
					<div className="whitespace-pre-line font-roboto font-medium text-[#344054] text-sm leading-5">
						{label}
					</div>
				)}

				{required && (
					<div className="font-roboto font-medium text-[#dc2538]">
						<span>*</span>
					</div>
				)}

				{children}
			</div>
		</ChakraFormLabel>
	);
};